/* ═══════════════════════════════════════════════
   RAJPUTANA CAMISA — theme.js
   Shopify Asset: assets/theme.js
═══════════════════════════════════════════════ */

'use strict';

/* ── Sticky Header ── */
(function() {
  const header = document.getElementById('site-header');
  if (!header) return;
  window.addEventListener('scroll', () => {
    header.classList.toggle('scrolled', window.scrollY > 50);
  }, { passive: true });
})();

/* ── Scroll Reveal ── */
(function() {
  const obs = new IntersectionObserver((entries) => {
    entries.forEach(e => { if (e.isIntersecting) e.target.classList.add('visible'); });
  }, { threshold: 0.1 });
  document.querySelectorAll('.reveal').forEach(el => obs.observe(el));
})();

/* ── Mobile Nav ── */
function rcToggleMobileNav() {
  const open = document.getElementById('mobile-nav').classList.toggle('open');
  document.getElementById('mobile-overlay').classList.toggle('open', open);
  document.getElementById('burger-btn').classList.toggle('open', open);
  document.body.style.overflow = open ? 'hidden' : '';
}
function rcCloseMobileNav() {
  document.getElementById('mobile-nav')?.classList.remove('open');
  document.getElementById('mobile-overlay')?.classList.remove('open');
  document.getElementById('burger-btn')?.classList.remove('open');
  document.body.style.overflow = '';
}

/* ── Cart Drawer ── */
function rcOpenCart() {
  document.getElementById('cart-drawer')?.classList.add('open');
  document.getElementById('cart-overlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function rcCloseCart() {
  document.getElementById('cart-drawer')?.classList.remove('open');
  document.getElementById('cart-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

/* ── Search ── */
function rcOpenSearch() {
  document.getElementById('search-overlay')?.classList.add('open');
  document.body.style.overflow = 'hidden';
  setTimeout(() => document.querySelector('.search-overlay__input')?.focus(), 100);
}
function rcCloseSearch() {
  document.getElementById('search-overlay')?.classList.remove('open');
  document.body.style.overflow = '';
}

/* ── Lightbox ── */
function rcOpenLightbox(src) {
  const lb = document.getElementById('rc-lightbox');
  const img = document.getElementById('rc-lightbox-img');
  if (!lb || !img) return;
  img.src = src;
  lb.classList.add('open');
  document.body.style.overflow = 'hidden';
}
function rcCloseLightbox() {
  document.getElementById('rc-lightbox')?.classList.remove('open');
  document.body.style.overflow = '';
}

/* ── Global Escape Key ── */
document.addEventListener('keydown', (e) => {
  if (e.key !== 'Escape') return;
  rcCloseCart(); rcCloseSearch(); rcCloseLightbox(); rcCloseMobileNav();
});

/* ── Lightbox: click outside to close ── */
document.getElementById('rc-lightbox')?.addEventListener('click', function(e) {
  if (e.target === this) rcCloseLightbox();
});

/* ── Active Nav Link ── */
(function() {
  const path = window.location.pathname;
  document.querySelectorAll('.site-nav__link, .site-nav__dropdown a, .mobile-nav__links a').forEach(link => {
    if (link.getAttribute('href') === path) link.classList.add('active');
  });
})();

/* ── Cart AJAX: Add to Cart ── */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.product-card__atc, .product-atc');
  if (!btn || btn.disabled) return;
  e.preventDefault();

  const variantId = btn.dataset.variantId
    || document.getElementById('product-variant-id')?.value;
  const quantity = parseInt(document.getElementById('qty')?.value || 1);
  if (!variantId) return;

  btn.textContent = 'Adding...';
  btn.disabled = true;

  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity })
  })
  .then(r => r.json())
  .then(() => {
    btn.textContent = 'Added!';
    rcRefreshCart();
    setTimeout(() => { btn.textContent = 'Add to Bag'; btn.disabled = false; }, 1500);
  })
  .catch(() => { btn.textContent = 'Error'; btn.disabled = false; });
});

/* ── Cart AJAX: Refresh Drawer ── */
function rcRefreshCart() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(cart => {
      // Update count
      const countEl = document.getElementById('cart-count');
      if (countEl) {
        countEl.textContent = cart.item_count;
        countEl.classList.toggle('cart-count--hidden', cart.item_count === 0);
      }
      // Refresh drawer body via sections API
      return fetch('/?sections=cart-drawer');
    })
    .then(r => r.json())
    .then(sections => {
      const body = document.getElementById('cart-drawer-body');
      if (body && sections['cart-drawer']) {
        body.innerHTML = sections['cart-drawer'];
      }
      rcOpenCart();
    })
    .catch(console.error);
}

/* ── Cart AJAX: Remove Item ── */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.cart-item__remove');
  if (!btn) return;
  const key = btn.dataset.key;
  if (!key) return;
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: 0 })
  })
  .then(() => rcRefreshCart())
  .catch(console.error);
});

/* ── Cart AJAX: Qty Change ── */
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.qty-btn[data-action]');
  if (!btn) return;
  const key = btn.dataset.key;
  const action = btn.dataset.action;
  const qtyEl = btn.closest('.cart-item__qty')?.querySelector('.qty-value');
  if (!key || !qtyEl) return;
  let qty = parseInt(qtyEl.textContent) || 1;
  qty = action === 'increase' ? qty + 1 : Math.max(0, qty - 1);
  fetch('/cart/change.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: key, quantity: qty })
  })
  .then(() => rcRefreshCart())
  .catch(console.error);
});

/* ── Product Page: Variant Selector ── */
(function() {
  const optionBtns = document.querySelectorAll('.option-btn');
  if (!optionBtns.length) return;

  optionBtns.forEach(btn => {
    btn.addEventListener('click', function() {
      // Deselect siblings
      const pos = this.dataset.optionPosition;
      document.querySelectorAll(`.option-btn[data-option-position="${pos}"]`).forEach(b => b.classList.remove('selected'));
      this.classList.add('selected');
      rcUpdateVariant();
    });
  });

  function rcUpdateVariant() {
    const selected = {};
    document.querySelectorAll('.option-btn.selected').forEach(btn => {
      selected[btn.dataset.optionPosition] = btn.dataset.value;
    });
    // Find matching variant from window.productVariants (set in product section)
    const variants = window.productVariants;
    if (!variants) return;
    const match = variants.find(v =>
      v.options.every((opt, i) => selected[String(i + 1)] === opt)
    );
    if (!match) return;
    document.getElementById('product-variant-id').value = match.id;
    const priceEl = document.getElementById('product-price');
    if (priceEl) priceEl.textContent = rcFormatMoney(match.price);
    const atcBtn = document.querySelector('.product-atc');
    if (atcBtn) {
      atcBtn.disabled = !match.available;
      atcBtn.textContent = match.available ? 'Add to Bag' : 'Sold Out';
      atcBtn.dataset.variantId = match.id;
    }
  }
})();

/* ── Money Formatter ── */
function rcFormatMoney(cents) {
  return '₹' + (cents / 100).toFixed(2).replace(/\.00$/, '');
}

/* ── Product Page: Related Products ── */
(function() {
  const el = document.getElementById('related-products');
  if (!el) return;
  fetch(el.dataset.url)
    .then(r => r.text())
    .then(html => {
      el.innerHTML = html;
      // Content injected after page load was never seen by the
      // IntersectionObserver set up above, so .reveal elements in here
      // (e.g. the section heading) would otherwise stay opacity:0 forever.
      // Show them immediately instead of trying to scroll-animate them in.
      el.querySelectorAll('.reveal').forEach((r) => r.classList.add('visible'));
    })
    .catch(console.error);
})();

/* ── Product Page Qty Buttons ── */
(function() {
  const dec = document.getElementById('qty-decrease');
  const inc = document.getElementById('qty-increase');
  const inp = document.getElementById('qty');
  if (!dec || !inc || !inp) return;
  dec.addEventListener('click', () => { if (parseInt(inp.value) > 1) inp.value = parseInt(inp.value) - 1; });
  inc.addEventListener('click', () => { inp.value = parseInt(inp.value) + 1; });
})();
